// toastManager.js
import { toast } from 'react-toastify';

/** Start (or flip back to) a loading toast for this key */
function start(key, msg = 'Loading…', opts = {}) {
  // Use the key as the toastId so updates work across files/modules
  toast.loading(msg, {
    toastId: key,
    autoClose: false,
    closeOnClick: false,
    ...opts,
  });
}

/** Mark success for this key's toast */
function success(key, msg = 'Success!', autoClose = 2000, opts = {}) {
  toast.update(key, {
    render: msg,
    type: 'success',
    isLoading: false,
    autoClose,
    closeOnClick: true,
    ...opts,
  });
}

/** Mark error for this key's toast */
function error(key, msg = 'Something went wrong', autoClose = 3000, opts = {}) {
  toast.update(key, {
    render: msg,
    type: 'error',
    isLoading: false,
    autoClose,
    closeOnClick: true,
    ...opts,
  });
}

/** Update message without changing state */
function update(key, msg, opts = {}) {
  toast.update(key, { render: msg, ...opts });
}

/** Dismiss one key (or all if no key) */
function dismiss(key) {
  if (key == null) {
    toast.dismiss();
  } else {
    toast.dismiss(key);
  }
}

export const toastManager = { start, success, error, update, dismiss };
